import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { navigateToMap } from "@shared/utils/utils";
import { ArrowLeft, MapPin, Package } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
interface AssetProfileCardProps {
  data: any;
}
export const AssetProfileCard: React.FC<AssetProfileCardProps> = ({ data }) => {
  const navigate = useNavigate();

  const assetFields = [
    { label: "Asset ID", value: data?.assetNo ?? "NA" },
    { label: "Asset Name", value: data?.assetName ?? "NA" },
    { label: "Asset Type", value: data?.assetTypeDisplay ?? "NA" },
    { label: "Installation Year", value: data?.installationYear ?? "NA" },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate(-1)}
          />
          <Package className="h-5 w-5 text-blue-600" />
          <CardTitle className="text-lg font-semibold">
            {data?.assetName}
          </CardTitle>
        </div>
        <p className="text-sm text-gray-600">
          Comprehensive asset information and operational details
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <>
            {assetFields.map((field, index) => (
              <ValueLabel label={field.label} value={field.value} />
            ))}
          </>

          <ValueLabel
            label="Manufacturer"
            value={data?.manufacturerName ?? "NA"}
          />

          <ValueLabel
            label="Serial Number"
            value={data?.serialNumber ?? "NA"}
          />

          <ValueLabel label="Status" value={data?.statusDisplay ?? "NA"} />

          <ValueLabel label="Facility" value={data?.facilityName ?? "NA"} />
        </div>
        <div>
          <p className="text-xs text-muted-foreground tracking-wide">
            Location
          </p>{" "}
          <div className="text-sm font-medium text-gray-900 flex items-center gap-2">
            {data?.location ?? "NA"}
            <Button
              variant="ghost"
              size="sm"
              className="text-blue-600 p-0 h-auto"
              onClick={() => navigateToMap(data?.latitude, data?.longitude)}
            >
              <MapPin className="h-4 w-4 mr-1" />
              View on map
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
